import { render, staticRenderFns } from "./rankingLing.vue?vue&type=template&id=79dd198a&scoped=true&"
import script from "./rankingLing.vue?vue&type=script&lang=js&"
export * from "./rankingLing.vue?vue&type=script&lang=js&"
import style0 from "./rankingLing.vue?vue&type=style&index=0&id=79dd198a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd198a",
  null
  
)

export default component.exports